import { useQuery } from '@tanstack/react-query';

import { fetchPatientOutboundReferrals } from '../api/fetchPatientOutboundReferrals';

export function usePatientOutboundReferralsQuery(userId: string | undefined) {
  return useQuery({
    queryKey: ['patient-outbound-referrals', userId ?? ''],
    queryFn: ({ signal }) => fetchPatientOutboundReferrals(userId ?? '', signal),
    enabled: Boolean(userId),
    meta: {
      toast: {
        title: 'Could not load sent referrals',
        description: 'Sent referrals could not be fetched.',
      },
    },
  });
}
